import { render, staticRenderFns } from "./xwzz_donate_index.vue?vue&type=template&id=777a6ea1&scoped=true"
import script from "./xwzz_donate_index.vue?vue&type=script&lang=js"
export * from "./xwzz_donate_index.vue?vue&type=script&lang=js"
import style0 from "./xwzz_donate_index.vue?vue&type=style&index=0&id=777a6ea1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777a6ea1",
  null
  
)

export default component.exports